
const configurationManager = require('../config/configurationManager');
const stateManager = require('../state/stateManager');
const stringUtil = require('../string/stringUtil');
const logger = require('../logger/logger');
const dateUtil = require('../dateUtil/dateUtil');

var storageDBRequest;
var storageDB;

const PreviousOrdersStoreName = "PreviousOrders";
const UserStoreName = "User";


module.exports.PreviousOrdersStoreName = PreviousOrdersStoreName;
module.exports.UserStoreName = UserStoreName;

module.exports.initializeStorage = function()
{
    var appConfig = configurationManager.getAppConfig();
    var state = stateManager.getStore().getState();

    if (stringUtil.isStringNullOrEmpty(state.applicationId))
        return Promise.resolve(false);

    if (storageDBRequest != null)
        return Promise.resolve(true);

    return new Promise((resolve, reject) =>
    {
        if (!appConfig.webOrderingLocalStorageEnabled)
            indexedDB.deleteDatabase(state.applicationId);
      
        storageDBRequest = indexedDB.open(state.applicationId, appConfig.webOrderingLocalStorageVersion);
        storageDBRequest.onerror = (event) => {
                                                    logger.error(`Failed to open local storage with error code ${event.target.errorCode}`);
                                                    resolve(false);
                                              }

        storageDBRequest.onsuccess = (event) => {
                                                    storageDB = storageDBRequest.result;
                                                    logger.info("Local Storage DB opened successfully")
                                                    resolve(true);

                                                }
        storageDBRequest.onupgradeneeded = (event) => {
                                                            try
                                                            {
                                                                logger.info("Creating stores...")
                                                                
                                                                let db = event.target.result;
                                                                crateStore(db, PreviousOrdersStoreName);
                                                                crateStore(db, UserStoreName);

                                                                logger.info("Stores created successfully.");
                                                            }
                                                            catch(error)
                                                            {
                                                                logger.error(`Failed to create stores with error code ${event.target.errorCode}`);
                                                            }
                                                            
                                                      }
    });
}

module.exports.readData = function(storeName, expiryInMinutes)
{
    return new Promise((resolve, reject) =>
    {
        const txn = storageDB.transaction(storeName, 'readonly');
        const store = txn.objectStore(storeName);

        var query = store.get(1);
        query.onerror = (event) => {
                                        logger.error(`Failed to read data from store: ${storeName} with error code ${event.target.errorCode}`);
                                        resolve(null);
                                    }

        query.onsuccess = (event) => {
                                        if (event.target.result == null ||
                                            event.target.result.data == null ||
                                            event.target.result.dateTime == null)
                                        {
                                            resolve(null);
                                            return;
                                        }

                                        var record = event.target.result;

                                        if (isExpired(record.dateTime, expiryInMinutes))
                                        {
                                            resolve(null);
                                        }
                                        else
                                        {
                                            resolve(record.data);
                                        }
                                    };
    });
}

module.exports.updateData = function(storeName, data)
{
    return new Promise((resolve, reject) =>
    {
        const txn = storageDB.transaction(storeName, 'readwrite');
        const store = txn.objectStore(storeName);

        var wrappedObject = {};
        wrappedObject.dateTime =  dateUtil.getNow();
        wrappedObject.data = data;

        var query = store.put(wrappedObject, 1)
        query.onerror = (event) => {
                                        logger.error(`Failed to insert data in store: ${storeName} with error code ${event.target.errorCode}`);
                                        resolve(false);
                                    }

        query.onsuccess = (event) => {
                                        resolve(true);
                                    };
    });
}

function crateStore(db, storeName)
{
    return new Promise((resolve, reject) =>
    {
        try
        {
            if (db.objectStoreNames.contains(storeName)) db.deleteObjectStore(storeName);
            let store =  db.createObjectStore(storeName, {autoIncrement: true});
            
            var test = {};
            test.data = null;
            test.dateTime = null;
            const request = store.add(test)
        
            request.onsuccess = ()=> {
                                        resolve(store);
                                     }
        
            request.onerror = (event)=> {
                                            logger.error(`Failed to insert empty record in store: ${storeName} with error code ${event.target.errorCode}`);
                                            resolve(store);
                                      }
        }
        catch(error)
        {
            reject(error);
        }
        
    });
}

function isExpired(creationDateTime, expiryInMinutes)
{
    var expiryDateTime =  dateUtil.addMinutes(creationDateTime, expiryInMinutes);
    var now = dateUtil.getNow();

    return dateUtil.isBefore(expiryDateTime, now);
}

